import Portal from "../shared/portal/portal";
import ButtonField from "../buttonField/buttonField";
import { ButtonFieldProps } from "../buttonField/types/buttonFieldProps";
import { classNameBtn } from "../shared/button/types/buttonProps";
import './modal.scss';
import { InfoModalProps } from "./types/infoModalProps";
import { useEffect, useRef } from "react";

const InfoModal = (props: InfoModalProps) => {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setTimeout(() => {
            containerRef.current?.focus();
        }, 0);
    }, []);
    
    const cancel = () => {
        if (props.onCancel) props.onCancel();
    }

    const getBtnProps = (title: string | undefined, btnClass: string, onClick: React.MouseEventHandler<HTMLButtonElement>): ButtonFieldProps => {
        return {
            BtnProps: {
                onClick: onClick,
                className: `${classNameBtn.Btn} ${btnClass} btn body-txt-medium`
            },
            placeHolder: title
        };
    }

    const keyboardNavClose = (event: any) => { 
        // Escape
        return event.keyCode === 27 && cancel(); 
    }

    return (
        <Portal>
            <div tabIndex={-1} onKeyDown={keyboardNavClose} ref={containerRef}>
                <div className="modalBackground"></div>
                <div className="modalContent">
                    <div className="confirmModal" style={{ width: props.width, height: props.height }}>
                        <div className="confirmModalBody body-txt-XL">
                            {props.information}
                        </div>
                        <div className="modalBtns">
                            <ButtonField key={1} {...getBtnProps(props.cancelTitle, classNameBtn.Small, cancel)}></ButtonField>
                        </div>
                    </div>
                </div>
            </div>
        </Portal>
    )
}

export default InfoModal;